import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_TopDownParser_Backtracking = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="TOP DOWN PARSER - Backtracking Method"
    videos={[
      "https://www.youtube.com/embed/a4qdbCQJhyA",
      "https://www.youtube.com/embed/Txr2dg24D_s",
    ]}
    takeaways={[
      { text: "When compared to other topics it is not that much important" },
    ]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_TopDownParser_Backtracking;
